<template>
  <div class="promotionPage" :style="`background-image:url(${promotionbg});`">
    <el-carousel :interval="10000" type="card" arrow="never" indicator-position="none">
      <el-carousel-item v-for="(item, index) in promotionList" :key="index">
        <div class="promotionContainer">
          <img :src="bonus" alt="">
          <div class="title">{{item.title}}</div>
          <div class="promotion">
            <div class="text1 text2 mb15" v-for="(desc, i) in item.text3" :key="'3'+i" v-html="desc"></div>
            <img :src="item.img" alt="">
            <div class="text1" v-for="(desc, i) in item.text1" :key="'1'+i" v-html="desc"></div>
            <div class="text1 text2" v-for="(desc, i) in item.text2" :key="'2'+i" v-html="desc"></div>
            <div class="duration" v-if="item.duration">{{$t('lang.promotion.promotionDuration')}}{{item.duration}}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import bonus from '@/assets/images/common/bonus.svg'
import {Carousel} from 'element-ui'
import {getMonthName, getDayName} from '@/utils'
import axios from 'axios'
import promotionbg from '@/assets/images/promotion/promotionbg.png'

export default {
  name: 'Promotion',
  data () {
    return {
      bonus,
      promotionList: [],
      getMonthName,
      getDayName,
      promotionbg
    }
  },
  components: {
    Carousel
  },
  mounted () {
    this.replaceCustomStrings()
    const url = location.origin + '/static/setting-' + this.$store.state.locale + '.json?v=220428'
    axios.get(url, null, true).then(res => {
      if (res.data != null) {
        this.promotionList = res.data.PromotionList
        this.replaceCustomStrings()
      }
    })
  },
  methods: {
    replaceCustomStrings () {
      let now = new Date()
      let monthName = getMonthName(now.getMonth() + 1)
      let monthNameUpperCase = monthName.toUpperCase()
      let currentMonthLastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      for (let index = 0; index < this.promotionList.length; index++) {
        if (this.promotionList[index].title) {
          this.promotionList[index].title = this.promotionList[index].title.replace(/#CurrentMonthUpper#/ig, monthNameUpperCase)
        }

        if (this.promotionList[index].text1) {
          for (let index2 = 0; index2 < this.promotionList[index].text1.length; index2++) {
            this.promotionList[index].text1[index2] =
              this.promotionList[index].text1[index2].replace(/#CurrentMonthUpper#/ig, monthNameUpperCase)
            this.promotionList[index].text1[index2] =
              this.promotionList[index].text1[index2].replace(/#CurrentMonthNormal#/ig, monthName)
            this.promotionList[index].text1[index2] =
              this.promotionList[index].text1[index2].replace(/#LastDateOfCurrentMonth#/ig, getDayName(currentMonthLastDay.getDate()) + ' ' + monthName)
          }
        }

        if (this.promotionList[index].text2) {
          for (let index3 = 0; index3 < this.promotionList[index].text2.length; index3++) {
            this.promotionList[index].text2[index3] =
              this.promotionList[index].text2[index3].replace(/#CurrentMonthUpper#/ig, monthNameUpperCase)
            this.promotionList[index].text2[index3] =
              this.promotionList[index].text2[index3].replace(/#CurrentMonthNormal#/ig, monthName)
            this.promotionList[index].text2[index3] =
              this.promotionList[index].text2[index3].replace(/#LastDateOfCurrentMonth#/ig, getDayName(currentMonthLastDay.getDate()) + ' ' + monthName)
          }
        }

        if (this.promotionList[index].text3) {
          for (let index4 = 0; index4 < this.promotionList[index].text3.length; index4++) {
            this.promotionList[index].text3[index4] =
              this.promotionList[index].text3[index4].replace(/#CurrentMonthUpper#/ig, monthNameUpperCase)
            this.promotionList[index].text3[index4] =
              this.promotionList[index].text3[index4].replace(/#CurrentMonthNormal#/ig, monthName)
            this.promotionList[index].text3[index4] =
              this.promotionList[index].text3[index4].replace(/#LastDateOfCurrentMonth#/ig, getDayName(currentMonthLastDay.getDate()) + ' ' + monthName)
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .promotionPage {
    padding: 25vw 0 50px 0;
    background: rgba(0,0,0,.8);
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: 70vw;
    overflow: hidden;
    .el-carousel {
      /*margin: 0 140px;*/
      padding: 0 20%;
      height: 60vh;
      overflow: visible;
      .el-carousel__item {
        /*width: 420px;*/
        height: auto;
        .promotionContainer {
          position: relative;
          text-align: center;
          img {
            margin-bottom: 33px;
          }
          .title {
            position: absolute;
            left: 50%;
            top: 68px;
            transform: translateX(-50%);
            width: 86%;
            font-size: 1.2vw;
            line-height: 55px;
            color: #000;
            font-weight: bold;
            background: linear-gradient(27.63deg, #885400 -42.83%, #FFE4B9 101.74%);
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
            border-radius: 10px 10px 0 0;
          }
          .promotion {
            height: max-content;
            padding: 15px;
            border: 1px solid #F6D9AA;
            border-radius: 0 0 10px 10px;
            img {
              width: 100%;
              margin-bottom: 15px;
            }
            div {
              color: #F6D9AA;
              display: flex;
              justify-content: center;
            }
            .text1 {
              font-size: 1.4vw;
              line-height: 30px;
              font-weight: bold;
              &:not(.text2) {
                letter-spacing: 1.5px;
                margin-bottom: 20px;
              }
            }
            .text2 {
              font-size: 1.0vw;
              line-height: 27px;
              font-weight: normal;
            }
            .duration {
              color: #00e6f4;
              font-size: 12px;
              margin-top: 15px;
            }
          }
        }
        &:not(.is-active) {
          opacity: 0.4;
        }
      }
      /deep/.el-carousel__container {
        height: 100%!important;
        .el-carousel__mask {
          height: auto;
          background: none;
        }
        .el-carousel__item {
          /*width: 350px;*/
          width: 36%;
        }
      }
    }
    .mb15 {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Promotion/index.vue